import { useState, useEffect } from "react";
import { useApi } from "providers/ProvideApi";
import { wrapError } from "../../utils";

export const useGetChapterQuestions = (topicId, chapterId) => {
  const { authApi } = useApi();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = async () => {
    try {
      const response = await authApi.get(
        `/api/topics/${topicId}/chapters/${chapterId}/questions`
      );
      setData(response.data);
    } catch (e) {
      setError(wrapError(e));
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const load = async () => {
      try {
        const response = await authApi.get(
          `/api/topics/${topicId}/chapters/${chapterId}/questions`
        );
        setData(response.data);
      } catch (e) {
        setError(wrapError(e));
      } finally {
        setIsLoading(false);
      }
    };
    load();
  }, [topicId]);

  return [data, refresh, isLoading, error];
};

export default useGetChapterQuestions;
